// @flow

// TODO (nkohari): The subscribe-to endpoint still lives on site-srv, so we can't
// go through the same Api/Endpoint infrastructure as everything else. Replace this
// once we are able to move it to an Endpoint in docs-proxy-srv.
export const subscribeToEmailList = (list: string, email: string) =>
  fetch(`/subscribe-to/${list}`, {
    method: 'post',
    body: JSON.stringify({email}),
    headers: {
      'Content-Type': 'application/json',
      'X-Stripe-CSRF-Token': '1',
    },
  });
